import { RotatingLines, ThreeDots } from 'react-loader-spinner';
import cn from 'classnames';
export const SubmitLoader = ({
   className,
   size = '30px',
   isDotsType = false,
   text = '',
   width = '50',
   color,
}: {
   className?: string;
   size?: string | number;
   isDotsType?: boolean;
   text?: string;
   width?: string;
   color?: string;
}) => {
   return (
      <div className={cn('flex flex-col items-center justify-center ', className)}>
         {isDotsType ? (
            <ThreeDots width={size} height={size} color={color || '#646EC8'} />
         ) : (
            <RotatingLines
               strokeColor="grey"
               strokeWidth="3"
               animationDuration="0.75"
               width={width}
               visible={true}
            />
         )}
         {text ? <div className="text-xs font-semibold text-grey-200 pt-4">{text}</div> : null}
      </div>
   );
};
